<template>
  <div>
    <v-row justify="center" align="center">
      <v-col cols="12" xs="12">
        <v-banner icon="mdi-group">
          Product Groups
          <template v-slot:actions>
            <v-btn text color="blue darken-2" exact @click="$router.go(-1)">
              <v-icon left>arrow_back</v-icon>Back
            </v-btn>
          </template>
        </v-banner>
      </v-col>
      <v-col cols="12" xs="12">
        <v-card flat color="background">
          <v-row
            justify="center"
            align="start"
            class="ma-0"
            style="width: 100%"
          >
            <v-col cols="12" sm="10" md="9" lg="8" xl="6" class="ma-0">
              <v-select
                :items="$store.getters['retrieveFormatedDists']"
                v-model="distributorSelected"
                v-if="isDistFilterEnabled"
                label="Choosen Distributor"
                outlined
              >
              </v-select>
            </v-col>
            <v-col cols="12" xs="12">
              <v-row justify="start" align="stretch">
                <v-col v-if="loadingProductGroups" cols="12" sm="12">
                  <v-card class="mx-auto" outlined height="100%" loading>
                    <v-card-title>Loading Groups...</v-card-title>
                    <template slot="progress">
                      <v-progress-linear
                        color="blue darken-2"
                        indeterminate
                      ></v-progress-linear>
                    </template>
                  </v-card>
                </v-col>
                <v-col v-else-if="groups.length == 0" cols="12" sm="12">
                  <v-card class="mx-auto" outlined height="100%">
                    <v-card-title
                      >No valid products found for your chosen delivery
                      date.</v-card-title
                    >
                    <template slot="progress">
                      <v-progress-linear
                        color="blue darken-2"
                        indeterminate
                      ></v-progress-linear>
                    </template>
                  </v-card>
                </v-col>
                <v-col
                  v-else
                  cols="12"
                  xl="2"
                  lg="3"
                  md="4"
                  sm="6"
                  v-for="(group, index) in groups"
                  :key="index"
                >
                  <v-card
                    class="mx-auto"
                    color="background"
                    outlined
                    hover
                    max-width="200px"
                    height="100%"
                    :disabled="loadingGroup.length != 0"
                    :loading="loadingGroup.includes(group.group_no)"
                    @click="getGroup(group.group_no, group.group_description)"
                    style="border: 0"
                  >
                    <v-row
                      justify="space-between"
                      align="stretch"
                      no-gutters
                      style="height: 100%"
                    >
                      <v-col cols="12" lg="12" xs="12">
                        <GroupImage :group="group"></GroupImage>
                      </v-col>
                      <v-col cols="12" lg="12" xs="12" align-self="end">
                        <v-card-title>{{
                          group.group_description
                        }}</v-card-title>

                        <template slot="progress">
                          <v-progress-linear
                            color="blue darken-2"
                            indeterminate
                          ></v-progress-linear>
                        </template>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

import GroupImage from "@/components/group/GroupImage.vue";

export default {
  name: "ProductGroups",
  components: {
    GroupImage,
  },
  props: {
    viewName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loadingProductGroups: false,
      loadingGroup: [],
      groups: [],
    };
  },
  watch: {
    distributorSelected(newVal) {
      this.getProductGroups();
    },
  },

  computed: {
    ...mapGetters(["isDistFilterEnabled", "isCategoriesShowEnabled"]),
    distributorSelected: {
      get() {
        return this.$store.state.customer.selectedDistributor;
      },
      set(val) {
        this.$store.commit("setSelectedDistributor", val);
      },
    },
    selectedStandingOrderDate() {
      if (this.$store.getters.retrieveCurrentStandingOrder) {
        return this.$store.getters.retrieveCurrentStandingOrder
          .trolly_header_info.order_date;
      }

      return false;
    },
  },

  async activated() {
    if (this.viewName == "search") {
      this.searchViewPreChecks();
    } else if (this.viewName == "template") {
      this.templateViewPreChecks();
    } else if (this.viewName == "standing") {
      this.standingViewPreChecks();
    }
    await this.getProductGroups();
  },

  methods: {
    ...mapActions("orderSearch", [
      "setGroups",
      "getGroupPriceList",
      "setLastOrderDate",
    ]),
    searchViewPreChecks() {
      console.log(this.$store.getters.retrieveCurrentTrolly);

      //Check if we have a valid troll before we let the user access this route
      if (
        this.$store.getters.retrieveCurrentTrolly == false &&
        !this.$store.getters.retrieveGuest
      ) {
        this.$router.push({ name: "OrdersCreate" });
        return;
      }

      //Check if we have groups set or not
      // -- No groups so load them here
      console.log("--- Getters");
      console.log(this.$store.getters["orderSearch/retrieveGroups"]);

      if (this.$store.getters["orderSearch/retrieveGroups"].length == 0) {
        this.getProductGroups();
      } else {
        //Check if it has been more than an hour since groupsLastUpdate

        if (this.groupRefreshRequired()) {
          this.getProductGroups();
        } else {
          this.groups = this.$store.getters["orderSearch/retrieveGroups"];
        }
      }
    },
    templateViewPreChecks() {
      console.log(this.$store.getters.retrieveCurrentTemplate);

      //Check if we have a valid troll before we let the user access this route
      if (
        this.$store.getters.retrieveCurrentTemplate == false &&
        !this.$store.getters.retrieveGuest
      ) {
        this.$router.push({ name: "TemplateOrders" });
        return;
      }
      if (this.$store.getters["templateSearch/retrieveGroups"].length == 0) {
        this.getProductGroups();
      } else {
        //Check if it has been more than an hour since groupsLastUpdate

        if (this.groupRefreshRequired()) {
          this.getProductGroups();
        } else {
          this.groups = this.$store.getters["templateSearch/retrieveGroups"];
        }
      }
    },
    standingViewPreChecks() {
      console.log(this.$store.getters.retrieveCurrentStandingOrder);

      if (
        this.$store.getters.retrieveCurrentStandingOrder == false &&
        !this.$store.getters.retrieveGuest
      ) {
        this.$router.push({ name: "StandingOrder" });
        return;
      }
      if (
        this.$store.getters["standingOrderSearch/retrieveGroups"].length == 0
      ) {
        this.getProductGroups();
      } else {
        if (this.groupRefreshRequired()) {
          this.getProductGroups();
        } else {
          this.groups = this.$store.getters[
            "standingOrderSearch/retrieveGroups"
          ];
        }
      }
    },
    orderDateChanged() {
      if (this.viewName == "search") {
        if (
          this.$store.state.orderSearch.lastOrderDate !=
          this.$store.getters.retrieveCurrentTrolly.order_date
        ) {
          return true;
        }
        return false;
      }
      return false;
    },

    groupRefreshRequired() {
      let refreshRequired = false;
      let milSecs =
        new Date().getTime() -
        this.$store.getters["orderSearch/retrieveLastUpdatedGroups"];
      let sec = milSecs / 1000;
      let mins = sec / 60;
      if (mins > 59 || this.orderDateChanged()) {
        refreshRequired = true;
      }
      return refreshRequired;
    },
    async getProductGroups() {
      this.loadingProductGroups = true;
      let selectedDist = this.$store.state.customer.selectedDistributor;
      let paramet = {
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        orderDate: this.$store.getters.retrieveCurrentTrolly.order_date,
        customerNo : this.$store.getters.retrieveSelectedCustomer
      };

      if (selectedDist != 0) {
        paramet.distNo = selectedDist;
      }
      if (this.viewName == "template") {
        paramet.orderDate = moment(new Date()).format("YYYY-MM-DD");
      } else if (this.viewName == "standing") {
        paramet.orderDate = this.selectedStandingOrderDate;
      }

      let stringPayload = JSON.stringify({
        ...paramet,
      });

      const params = new URLSearchParams();
      params.append("params", stringPayload);

      let response = await axios
        .post("get-prod-group-cat2", params)
        .catch((err) => {
          console.log(err);
        });

      if (response) {
        console.log("-- Group Cat Response");
        console.log(response);
        this.groups = response.data.prodgroupscats;
        if (this.viewName == "search") {
          this.setGroups(this.groups);
          this.setLastOrderDate(
            this.$store.getters.retrieveCurrentTrolly.order_date
          );
        } else if (this.viewName == "template") {
          this.$store.dispatch("templateSearch/setGroups", this.groups);
        } else if (this.viewName == "standing") {
          this.$store.dispatch("standingOrderSearch/setGroups", this.groups);
        }
      }

      this.loadingProductGroups = false;
    },

    async getGroup(groupNum, description) {
      this.showGroups = false;
      this.loadingGroup.push(groupNum);
      let parameters = {
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        orderDate: this.$store.getters.retrieveCurrentTrolly.order_date,
        groupNum: groupNum,
        customerNo : this.$store.getters.retrieveSelectedCustomer,
      };
      if (this.viewName == "template") {
        parameters.orderDate = moment(new Date()).format("YYYY-MM-DD");
      } else if (this.viewName == "standing") {
        parameters.orderDate = this.selectedStandingOrderDate;
      }

      let stringPayload = JSON.stringify({
        ...parameters,
      });

      //load categories of a group if global config is enabaled
      if (this.isCategoriesShowEnabled) {
        this.loadCategories(groupNum);
      } else {
        this.loadGroupPriceList(stringPayload, description);
      } //else load group pricelist+
      
    },

    loadGroupPriceList(payload, description) {
      if (this.viewName == "search") {
        this.getGroupPriceList({ payload, description });
        this.loadingGroup = [];
        this.$router.push({ name: "OrdersSearch" });
      } else if (this.viewName == "template") {
        this.$store.dispatch("templateSearch/getGroupPriceList", {
          payload,
          description,
        });
        this.loadingGroup = [];
        this.$router.push({ name: "TemplateOrdersEdit" });
      } else if (this.viewName == "standing") {
        this.$store.dispatch("standingOrderSearch/getGroupPriceList", {
          payload,
          description,
        });
        this.loadingGroup = [];
        this.$router.push({ name: "StandingOrderProducts" });
      }
    },

    loadCategories(groupNo) {
      console.log('ROUTE TO NEW PAGE AND SHOW ALL CATS OF A GROUP');
      if (this.viewName == "search") {
        this.loadingGroup = [];
        this.$store.commit('orderSearch/setSelectedGroup',groupNo);
        this.$router.push({ name: "OrdersSearchGroupCategories",params: { id: groupNo } });
      } else if (this.viewName == "template") {
        this.loadingGroup = [];
        this.$store.commit('templateSearch/setSelectedGroup',groupNo);
        this.$router.push({ name: "TemplateOrdersCategories" , params: { id: groupNo }});
      } else if (this.viewName == "standing") {
        this.loadingGroup = [];
        this.$store.commit('standingOrderSearch/setSelectedGroup',groupNo);
        this.$router.push({ name: "StandingOrderCategories" , params : {id: groupNo} });
      }
    }
  },
};
</script>

<style lang="sass" scoped>
*
  word-break: break-word
</style>